import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-image',
  props: {
  messageContent: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})